import React from "react"
import Image from "../image"

class HowToUsePicks extends React.Component {
  render() {
    return (
      <div className="how-to-use-picks">
        <div className="container">
          <div data-aos="fade-up" className="has-text-centered">
            <h2 className="title is-2">Picksの使い方</h2>
          </div>
          <div>
            <div className="columns">
              <div
                data-aos="fade-up"
                className="column is-relative has-text-centered"
              >
                <div className="step is-1">01</div>
                <div className="title is-5">
                  お客様の
                  <br />
                  注文を受付
                </div>
                <div className="mt-12">
                  <small>
                    お客様から注文が入ると自動電話とアプリでお知らせ
                  </small>
                </div>
                <div className="image">
                  <Image filename="PicksforPartners/how-to-use-picks-1.png" />
                </div>
              </div>
              <div
                data-aos="fade-up"
                className="column is-relative has-text-centered"
              >
                <div className="step is-2">02</div>
                <div className="title is-5">
                  お渡し時間までに
                  <br />
                  調理しましょう
                </div>
                <div className="mt-12">
                  <small>お客様が設定した時刻までに 調理を終えましょう</small>
                </div>
                <div className="image">
                  <Image filename="PicksforPartners/how-to-use-picks-2.png" />
                </div>
              </div>
              <div
                data-aos="fade-up"
                className="column is-relative has-text-centered"
              >
                <div className="step is-3">03</div>
                <div className="title is-5">
                  料理ができたら
                  <br />
                  お客様にお知らせ
                </div>
                <div className="mt-12">
                  <small>
                    調理完了したらボタンをタップし お客様へお知らせします。
                  </small>
                </div>
                <div className="image">
                  <Image filename="PicksforPartners/how-to-use-picks-3.png" />
                </div>
              </div>
              <div
                data-aos="fade-up"
                className="column is-relative has-text-centered"
              >
                <div className="step is-4">04</div>
                <div className="title is-5">
                  お客様に
                  <br />
                  料理を渡す
                </div>
                <div className="mt-12">
                  <small>
                    お客様が受け取りに来たら 料理を渡し「お渡し完了」！
                  </small>
                </div>
                <div className="image">
                  <Image filename="PicksforPartners/how-to-use-picks-4.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default HowToUsePicks
